"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagFK = function FlagFK(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.3v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.48v5.6a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.48L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122H-101.2v56.5H-193v21.18h91.8v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.23a6.94,6.94,0,0,0-3.37,5.86v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M71.57,89.29l-3.32-7.73,1.66,3.87-1.68-3.86c.7-.31,17.11-7.8,17.11-29.8h8.41c0,27.69-21.28,37.13-22.18,37.52Zm0,0",
    transform: "translate(194 123)",
    fill: "#e67346"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M74.86,70.47l-6-6C80.28,53.15,86.19,50,86.83,49.71l3.76,7.52-1.88-3.76,1.91,3.75c-.05,0-5.38,2.87-15.76,13.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#eb7d4b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M158,89.29l3.32-7.73-1.65,3.87,1.67-3.86c-.7-.31-17.1-7.8-17.1-29.8h-8.42c0,27.69,21.28,37.13,22.18,37.52Zm0,0",
    transform: "translate(194 123)",
    fill: "#e67346"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M154.75,70.47l5.95-6C149.32,53.15,143.41,50,142.77,49.71L139,57.23l1.88-3.76L139,57.22c.05,0,5.38,2.87,15.77,13.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#eb7d4b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.79-57.63H69.91V9.69c0,14,2.8,50.49,44.88,64.51,42.07-14,44.88-50.49,44.88-64.51V-57.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M134.42-40.8H110.31a11.23,11.23,0,0,1-7-2.46l-9.42-7.53A5.57,5.57,0,0,0,90.38-52h-.84a5.61,5.61,0,0,0-5.61,5.61h-4.2a4.2,4.2,0,0,0-4.21,4.2A4.2,4.2,0,0,0,79.73-38h4.2a2.81,2.81,0,0,1,2.81,2.8v14a11.21,11.21,0,0,0,8.41,10.83v8.8h5.61l2.11-8.41h25.94l2.81,2.81v5.6h2.81V-9.95h2.8v8.41H140v-9.19a5.57,5.57,0,0,0,2.81-4.83V-32.39a8.41,8.41,0,0,0-8.42-8.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M83.93-4.34l5.61,16.83H140l5.61-16.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M144.67,6.88c-7.47,0-7.47,5.61-15,5.61s-7.47-5.61-15-5.61-7.47,5.61-15,5.61-7.47-5.61-15-5.61-7.47,5.58-14.91,5.61a84.45,84.45,0,0,0,1,11.17c6.4-.52,6.78-5.56,13.86-5.56,7.49,0,7.49,5.61,15,5.61s7.48-5.61,15-5.61,7.47,5.61,14.94,5.61,7.49-5.61,15-5.61c7.11,0,7.49,5,13.91,5.56a84.3,84.3,0,0,0,1-11.17c-7.47,0-7.47-5.61-15-5.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M144.67,18.1c-7.47,0-7.47,5.61-15,5.61s-7.47-5.61-15-5.61-7.47,5.61-15,5.61-7.47-5.61-15-5.61c-7.08,0-7.46,5-13.86,5.56a73.77,73.77,0,0,0,2.58,10.7c4.09-1.43,5.29-5,11.28-5,7.48,0,7.48,5.61,15,5.61s7.48-5.61,15-5.61,7.48,5.61,15,5.61,7.49-5.61,15-5.61c6,0,7.21,3.62,11.33,5a73.46,73.46,0,0,0,2.58-10.7c-6.42-.51-6.8-5.56-13.91-5.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M144.67,29.32c-7.47,0-7.47,5.61-15,5.61s-7.47-5.61-15-5.61-7.47,5.61-15,5.61-7.47-5.61-15-5.61c-6,0-7.19,3.61-11.28,5a64.11,64.11,0,0,0,3.73,9c1.9-1.42,3.76-2.87,7.55-2.87,7.48,0,7.48,5.61,15,5.61s7.48-5.61,15-5.61,7.48,5.61,15,5.61,7.49-5.61,15-5.61c3.82,0,5.69,1.46,7.6,2.89A64.82,64.82,0,0,0,156,34.36c-4.12-1.42-5.31-5-11.33-5Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M144.67,40.54c-7.47,0-7.47,5.61-15,5.61s-7.47-5.61-15-5.61-7.47,5.61-15,5.61-7.47-5.61-15-5.61c-3.79,0-5.65,1.45-7.55,2.87A57.45,57.45,0,0,0,82.59,52a12,12,0,0,1,2.26-.2c7.48,0,7.48,5.61,15,5.61s7.48-5.61,15-5.61,7.48,5.61,15,5.61,7.49-5.61,15-5.61A12.29,12.29,0,0,1,147,52a58.4,58.4,0,0,0,5.29-8.55c-1.91-1.43-3.78-2.89-7.6-2.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M147,52a11.51,11.51,0,0,0-2.31-.21c-7.47,0-7.47,5.61-15,5.61s-7.47-5.61-15-5.61-7.47,5.61-15,5.61-7.47-5.61-15-5.61a12,12,0,0,0-2.26.2,59.51,59.51,0,0,0,19,16.48C107.33,67.61,108,63,114.76,63s7.44,4.65,13.15,5.48A59.62,59.62,0,0,0,147,52Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "307.38",
    y: "129.88",
    width: "2.81",
    height: "47.69",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "300.37",
    y: "136.89",
    width: "16.83",
    height: "2.81",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "300.37",
    y: "153.72",
    width: "16.83",
    height: "2.8",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "300.37",
    y: "139.69",
    width: "16.83",
    height: "11.1",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M113.39,6.88v5.61L105,9.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "326.09",
    y: "129.88",
    width: "2.8",
    height: "32.96",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "319.07",
    y: "136.89",
    width: "16.83",
    height: "2.81",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "319.07",
    y: "153.72",
    width: "16.83",
    height: "2.8",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "319.07",
    y: "139.69",
    width: "16.83",
    height: "11.1",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M132.09,6.88v5.61l-8.42-2.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "288.57",
    y: "129.88",
    width: "2.81",
    height: "32.72",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "281.56",
    y: "136.89",
    width: "16.83",
    height: "2.81",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "281.56",
    y: "153.72",
    width: "16.83",
    height: "2.8",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "281.56",
    y: "139.69",
    width: "16.83",
    height: "11.1",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M94.57,6.88v5.61l-8.42-2.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M128.81,37.74a14,14,0,1,1-28,0H95.18l-19-4.29-.62,2.73,8.37,1.89v2.47L90.1,43a25.23,25.23,0,0,0,49.28.34h9.07V34.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M159.67-57.63V9.69c0,14-2.81,50.49-44.88,64.51-42.08-14-44.88-50.49-44.88-64.51V-57.63h89.76m2.8-2.81H67.1V9.69C67.1,43,83.72,66.8,113.9,76.87l.89.29.89-.29C145.86,66.8,162.47,43,162.47,9.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.79,88.23c-20.65,0-39.79-6.92-51.22-18.5l8-7.88C80.92,71.34,97.08,77,114.79,77S148.66,71.34,158,61.85l8,7.88c-11.43,11.58-30.58,18.5-51.22,18.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagFK;
exports["default"] = _default;